import { useCallback, useState } from 'react';
const useInvestWalkthroughLayout = () => {
    const [itemPositions, setItemPositions] = useState({});
    const onLayout = useCallback((item, event) => {
        const layout = { ...event.nativeEvent?.layout };
        setItemPositions((s) => ({
            ...s,
            [item]: layout,
        }));
    }, []);
    const [scrollHeight, setScrollHeight] = useState(0);
    const onContentSizeChange = useCallback((_, height) => {
        setScrollHeight(height);
    }, []);
    const [scrollLayoutHeight, setScrollLayoutHeight] = useState(0);
    const [screenHeight, setScreenHeight] = useState(0);
    const onScrollLayout = useCallback((event) => {
        setScrollLayoutHeight(event.nativeEvent.layout.height);
    }, []);
    const onScreenLayout = useCallback((event) => {
        setScreenHeight(event.nativeEvent.layout.height);
    }, []);
    return {
        screenHeight,
        itemPositions,
        scrollHeight,
        scrollLayoutHeight,
        onLayout,
        onContentSizeChange,
        onScrollLayout,
        onScreenLayout,
    };
};
export default useInvestWalkthroughLayout;
